import Request from '@/api/request';

/**
 * @description: user login api
 */

export const getJournals = async (params, start = 0, limit = 100) => {
  const requestParams = {
    ...params,
    filter: {
      ...params.filter,
      status: 100
    },
    sort: {
      'ranking' : -1,
      // 'id'      : -1,
    },
    pagination: {
      'start' : start,
      'limit' : limit,
    }
  };
  return await Request.get('/v1/journals', requestParams).then((res) => {
    return res;
  });
};

export const getJournal = async (id) => {
  let params = {};
  return await Request.get('/v1/journals/' + id, params).then((res) => {
    return res;
  });
};

export const putJournal = async (id, params) => {
  console.log('putJournal:',id, params);
  return await Request.put('/v1/journals/'+id, params).then((res) => {
    return res;
  });
}

export const postJournal = async (file, params) => {
  return await Request.fileformpost('/v1/journals', 'filecover', file, params).then((res) => {
    return res;
  });
}

export const postJournalCover = async (journalid, filecover) => {
  let uri = '/v1/journals/'+journalid+'/cover';
  return await Request.fileformpost(uri, 'filecover', filecover).then((res) => {
      return res;
  });
}

export const putJournalOffline = async (id) => {
  return await Request.put('/v1/journals/'+id + '/offline', {}).then((res) => {
      return res;
  });
}

export const putJournalOnline = async (id) => {
  return await Request.put('/v1/journals/'+id + '/online', {}).then((res) => {
      return res;
  });
}


export const getEventJournals = async (eventid, params) => {
  return await Request.get('/v1/events/'+eventid+'/journals', params).then((res) => {
    return res;
  });
};

export const postEventJournal = async (eventid, journalid, params) => {
  return await Request.formpost('/v1/events/'+eventid+'/journals/from/'+journalid, params).then((res) => {
      return res;
  });
};

export const putEventJournal = async (eventid, id, params) => {
  return await Request.put('/v1/events/'+eventid+'/journals/'+id, params).then((res) => {
      return res;
  });
}

export const postEventJournalCover = async (eventid, filecover, params) => {
  const journalid = params.journalid;
  let uri = '/v1/events/'+eventid+'/journals/'+journalid+'/cover';
  return await Request.fileformpost(uri, 'filecover', filecover).then((res) => {
      return res;
  });
}

export const putJournalMarkdown = async (journalid, params) => {
  params.type = 0;
  return await Request.put('/v1/journals/'+journalid+'/richtext', params).then((res) => {
    return res;
  });  
};

export const getJournalMarkdown = async (journalid) => {
  return await Request.get('/v1/journals/'+journalid+'/richtext',{type:0}).then((res) => {
    return res;
  });  
};